











import { Modals } from '@/mixins/modals'
import { Mixins, Component } from 'vue-property-decorator'
import { ModalStore, IModalParams } from '~/store/modal'

@Component
export default class ConfirmActionModal extends Mixins(Modals) {
    @ModalStore.State('activeModal') activeModal: IModalParams

    callback() {
        this.activeModal.callback()
    }
}
